import axios from "axios"
import {calculateUploadProgress, startFakeProgress} from "./uploadProgressUtils"
import type {CropParams} from "../types/types"

const createFormData = (
    file: File,
    cropParams: CropParams,
    startTime: number,
    endTime: number
): FormData => {
    const formData = new FormData()

    const cropX1 = Math.floor(cropParams.sourceX)
    const cropY1 = Math.floor(cropParams.sourceY)
    const cropX2 = Math.floor(cropParams.sourceX + cropParams.sourceCropWidth)
    const cropY2 = Math.floor(cropParams.sourceY + cropParams.sourceCropHeight)

    formData.append("file", file)
    formData.append("crop_x1", cropX1.toString())
    formData.append("crop_y1", cropY1.toString())
    formData.append("crop_x2", cropX2.toString())
    formData.append("crop_y2", cropY2.toString())
    formData.append("start_time", startTime.toString())
    formData.append("end_time", endTime.toString())
    formData.append("remove_audio", "true")
    formData.append("output_format", "mp4")

    return formData
}

export const getVideoByFFmpeg = async (
    file: File,
    cropParams: CropParams,
    startTime: number,
    endTime: number,
    videoProcessingApi: string = "https://backend.mckp.live/process-video",
    onProgress?: (progress: number) => void
) => {
    const apiUrl = videoProcessingApi
    const formData = createFormData(file, cropParams, startTime, endTime)

    try {
        let progressInterval: number | null = null

        const response = await axios.post(apiUrl, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "video/mp4",
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = calculateUploadProgress(
                    progressEvent,
                    onProgress
                )

                if (percentCompleted >= 50 && !progressInterval) {
                    progressInterval = startFakeProgress(50, onProgress)
                }
            },
        })

        if (progressInterval) clearInterval(progressInterval)
        if (onProgress) onProgress(100)

        return response.data.download_url
    } catch (error) {
        console.error("Error processing video:", error)
        throw error
    }
}
